// extracted by mini-css-extract-plugin
export default {"priceBlock":"priceBlock__ZwD+W"};